import { PaletteMode } from "@mui/material";
import { red, yellow, green } from "@mui/material/colors";
import createTheme from "@mui/material/styles/createTheme";
import { isDatePickerView } from "@mui/x-date-pickers/internals";

declare module "@mui/material/styles" {
  interface Palette {
    primaryChart: string;
    secondaryChart: string;
    terciaryChart: string;
  }
  interface PaletteOptions {
    primaryChart: string;
    secondaryChart: string;  
    terciaryChart: string;
  }
}
// A custom theme for this app
export function getTheme(primary? : string, mode : PaletteMode = "light") {

  primary = primary ? primary : "#5BBFAC";
  var isDarkMode = mode !== "light";
  var background = isDarkMode ? "#272727" : "#f5f5f5";
  var secondaryBackground = isDarkMode ? "#272727" : "white";

  let theme = createTheme({
    typography: {
      h4: {
        marginTop: "1rem",
        color: isDarkMode ? "#9f9f9f" : "#888888"
      }
    },
    palette: {
      text: {
        primary: isDarkMode ? "#ffffff" : "#000000", // Default text color
        secondary: isDarkMode ? "#b0b0b0" : "#5e5e5e", // Secondary text color
        disabled: isDarkMode ? "#757575" : "#9e9e9e", // Disabled text color
      },
      mode: mode,
      primaryChart: "rgba(75, 192, 192, 1)",
      secondaryChart: "rgba(255, 99, 132, 1)",
      terciaryChart: "rgba(255, 206, 86, 1)",
      primary: {
        main: primary,
      },
      warning: red,
      info: yellow,
      success: green,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            backgroundColor: "#f5f5f5", // Set the background color of the navigation bar
            boxShadow: 'none'
          },
        },
      },
      
      // MuiListItemButton: {
      //   styleOverrides: {
      //     root: {
      //       ":hover": {
      //         borderTopRightRadius: 30,
      //         borderBottomRightRadius: 30,
      //         backgroundColor: primary,
      //       }, 
      //       "&.Mui-selected": {
      //         opacity: 0.7,
      //         borderTopRightRadius: 30,
      //         borderBottomRightRadius: 30,
      //         backgroundColor: primary,
      //       },
      //     },
      //   },
      // },
      MuiPaper:{
        styleOverrides:{
          root:{
            backgroundColor: secondaryBackground,
            //boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", // Increase the shadow size
            boxShadow: "0px 18px 40px rgba(0, 0, 0, 0.2)",

          },
        }
      },
      MuiDrawer:{
        styleOverrides:{
          paper:{
            backgroundColor: background,
            border: 0,
          },
        }
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: background,
            //Scrollbar for Chrome, safari etc.
            // scrollbarColor: `${primary} ${secondary}`,
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: isDarkMode ? "#272727" : "#f5f5f5",
              width: "15px",
            },

          },
        },
      },

      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:last-child td": {
              borderBottom: 0,
            },
          },
        },
      },
      // CTRL + SPACE to find the component you would like to override.
      // For most of them you will need to adjust just the root...
      MuiTextField: {
        styleOverrides: {
          root: {
            //DOnt know if we want to customize this.

            // "& label": {
            //   color: secondary,
            // },
            // "& label.Mui-focused": {
            //   color: isDarkMode ? "white" : secondary,
            // },
            // "& .MuiInput-underline:after": {
            //   borderBottomColor: secondary,
            // },

            //   "&:hover fieldset": {
            //     borderColor: secondary,
            //     borderWidth: "0.15rem",
            //   },
            //   "&.Mui-focused fieldset": {
            //     borderColor: secondary,
            //   },
            // },
            "& input::placeholder": {
              fontSize: "14px",
            },
          },
        },
      },
    },
  });

  return theme;
}
